import { User } from "lucide-react-native";
import { FC } from "react";

import { Box, Card, HStack, Text, VStack } from "@/components/ui";

import { Verbatim } from "./types";

/* ── Types ─────────────────────────────────────── */

interface VerbatimCardProps {
  /** Number of quote lines before clamping (web only). */
  clamp?: number;
  verbatim: Verbatim;
}

/* ── Constants ─────────────────────────────────── */

const PURPLE = "#7c3aed";
const PURPLE_BG = "#f5f3ff";

/* ── Component ─────────────────────────────────── */

/** One simulated respondent, styled like the product's answer cards. */
const VerbatimCard: FC<VerbatimCardProps> = ({ clamp = 6, verbatim }) => (
  <Card className="p-5 rounded-2xl border border-outline-200 bg-background-0 h-full">
    <VStack className="h-full justify-between gap-4">
      <HStack className="items-center gap-3">
        <Box
          className="w-10 h-10 rounded-full items-center justify-center shrink-0"
          style={{ backgroundColor: PURPLE_BG }}
        >
          <User color={PURPLE} size={18} />
        </Box>
        <VStack className="gap-0.5 min-w-0 flex-1">
          <Text className="text-sm font-semibold text-typography-900 leading-5">
            {verbatim.age} years old · {verbatim.gender}
          </Text>
          <Text className="text-xs text-typography-400" numberOfLines={1}>
            {verbatim.state}, United States
          </Text>
        </VStack>
      </HStack>
      <Text
        className="text-sm text-typography-500 leading-relaxed italic overflow-hidden"
        // @ts-expect-error - web-only CSS for line clamping
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: clamp,
        }}
      >
        {verbatim.quote}
      </Text>
    </VStack>
  </Card>
);

export default VerbatimCard;
